import { cn } from "@shadcn/lib/utils"

function Skeleton({ className, ...props }: Readonly<React.ComponentProps<"div">>) {
	return <div data-slot="skeleton" className={cn("bg-neutral-100 animate-pulse rounded-md", className)} {...props} />
}

export { Skeleton }
